<mat-card appearance="outlined" class="card pointer" (click)="conhecerProjeto()" >
  <div class="project-image-container" >
    <img class="project-pic" mat-card-image [src]="imageUrl" (error)="useDefaultPic()" alt="Imagem {{project.descricao}}">
  </div>  
  
  <mat-card-content>
      <span class="title">{{project.descricao}}</span>
  </mat-card-content>

  <div style="text-align: center;">
    <app-button [txt]="'CONHEÇA O PROJETO'" [class]="'border-blue-filled'" 
      [customStyle]="'border: 2px solid #007AC2; background-color: #007AC2; border-radius: 20px; color:white'">
    </app-button>
  </div>
</mat-card>